var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMileage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.788 7.683c1-1 .892-2.73-.24-3.862C3.413 2.688 1.684 2.58.684 3.579s-.891 2.73.242 3.862 2.862 1.241 3.861.242m4.266-2.221a2.73 2.73 0 1 0 0-5.462 2.73 2.73 0 0 0 0 5.462m7.509 0a2.73 2.73 0 1 0 0-5.462 2.73 2.73 0 0 0 0 5.462m7.622 2.781c1.042-1.09 1.088-2.738.102-3.681s-2.63-.826-3.673.264-1.089 2.738-.103 3.682c.986.943 2.63.825 3.674-.265M12.698 6.342a1.44 1.44 0 0 0-1.16.103C9.23 7.708 4.266 8.875 2.914 16.07c-.219 1.168-.84 3.018 0 4.964.846 1.945 2.97 3.789 4.943 3.543 2.061-.26 2.6-2.137 4.6-2.048 2.41.102 2.049 2.048 5.292 2.048 2.396 0 4.792-3.885 4.942-7.087.205-4.382-3.727-8.956-9.994-11.141z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMileage);
export default __webpack_public_path__ + "static/media/Mileage.0366b6d4e4ec591179a9b5a5685d6cba.svg";
export { ForwardRef as ReactComponent };